import { BaseAPI } from "@/api/base.api";
import { VUE_APP_SIT_API_URL } from "@/commons/config";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import {
  DaeRegulacao,
  ListaDaesRegulacaoResponse,
  ReemissaoResponse
} from "@/models/taxaRegulacao";

export default class TaxaRegulacaoAPI extends BaseAPI<DaeRegulacao> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_SIT_API_URL}`;
  }

  public listarPagos(
    transportadoraId: number,
    cnpj: string
  ): AxiosObservable<ListaDaesRegulacaoResponse> {
    return this.axios.post(`${this.apiUrl}/boletos/listarDaesRegulacaoPagos`, {
      transportadoraId,
      cnpj
    });
  }

  public reemitir(
    transportadoraId: number,
    cnpj: string,
    numeroDae: string,
    novaDataVencimento: string
  ): AxiosObservable<ReemissaoResponse> {
    return this.axios.post(`${this.apiUrl}/boletos/reemitirDaeRegulacao`, {
      transportadoraId,
      cnpj,
      numeroDae,
      novaDataVencimento
    });
  }
}

export { TaxaRegulacaoAPI };
